import { create } from 'zustand';

type UseHaulierEoriState = {
  hasHaulierEoriBeenSaved: boolean;
};

export const useHaulierEoriState = create<UseHaulierEoriState>(() => ({
  hasHaulierEoriBeenSaved: false,
}));
